import { roundUsd } from "./manufacturerPayablesMath.js";

export type CashPictureInput = {
  manufacturer_ap_remaining_usd: number;
  po_outstanding_usd: number;
  expected_in_usd: number;
};

export type CashPicture = {
  manufacturer_ap_remaining_usd: number;
  po_outstanding_usd: number;
  expected_in_usd: number;
  expected_out_usd: number;
};

/** Near-term cash out = manufacturer AP still owed + open PO dollars. */
export function buildCashPicture(input: CashPictureInput): CashPicture {
  const manufacturer_ap_remaining_usd = roundUsd(input.manufacturer_ap_remaining_usd);
  const po_outstanding_usd = roundUsd(input.po_outstanding_usd);
  const expected_in_usd = roundUsd(input.expected_in_usd);
  return {
    manufacturer_ap_remaining_usd,
    po_outstanding_usd,
    expected_in_usd,
    expected_out_usd: roundUsd(manufacturer_ap_remaining_usd + po_outstanding_usd),
  };
}

export const OPEN_PO_STATUSES_FOR_CASH = [
  "issued",
  "confirmed",
  "partially_received",
] as const;
